import { render, staticRenderFns } from "./ReservationTest.vue?vue&type=template&id=25b1d5a2&scoped=true"
import script from "./ReservationTest.vue?vue&type=script&lang=js"
export * from "./ReservationTest.vue?vue&type=script&lang=js"
import style0 from "./ReservationTest.vue?vue&type=style&index=0&id=25b1d5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1d5a2",
  null
  
)

export default component.exports